import { COMPONENT_TYPE, TTrackEventData } from './../../../tracking/constant/index';
export const COURIER_TRACKING_EVENTS = {
  TYPE: 'Couriers',
  COMPONENT_NAME: 'courier invitations',
  INVITATION_SEND_SUCCESS: {
    event: 'courierInvitation_sendSuccess',
    action: 'invitation send success',
    component_type: 'form',
  },
  INVITATION_SEND_START: {
    event: 'courierInvitation_sendStart',
    action: 'invitation send start',
    component_type: 'form',
  },

  INVITATION_SEND_INVITE_AGAIN_START: {
    event: 'courierInvitation_inviteAgain',
    action: 're-invite start',
    component_type: 'form',
  },
  INVITATION_SEND_INVITE_AGAIN_SUCCESS: {
    event: 'courierInvitation_inviteAgain',
    action: 're-invite complete',
    component_type: 'form',
  },
  INVITATION_DISCONNECT_START: {
    event: 'courierInvitation_disconnectStart',
    action: 'disconnect start',
    component_type: 'form',
  },
  INVITATION_DISCONNECT_SUCCESS: {
    event: 'courierInvitation_disconnectComplete',
    action: 'disconnect complete',
    component_type: 'form',
  },

  INVITATION_GUEST_CONNECT_START: {
    event: 'courierInvitation_connect',
    action: 'connect start',
    component_type: 'form',
  },
  INVITATION_GUEST_CONNECT_SUCCESS: {
    event: 'courierInvitation_connect',
    action: 'connect complete',
    component_type: 'form',
  },
  INVITATION_GUEST_DECLINE: {
    event: 'courierInvitation_decline',
    action: 'decline',
    component_type: 'form',
  },
  INIVTATION_GUEST_DECLINE_START: {
    event: 'courierInvitation_decline',
    action: 'decline start',
    component_type: 'form',
  },
  INVITATION_GUEST_DECLINE_SUCCESS: {
    event: 'courierInvitation_decline',
    action: 'decline complete',
    component_type: 'form',
  },
  INVITATION_REMOVE_START: {
    event: 'courierInvitation_remove',
    action: 'remove start',
    component_type: 'form',
  },
  INVITATION_REMOVE_SUCCESS: {
    event: 'courierInvitation_remove',
    action: 'remove complete',
    component_type: 'form',
  },
  COURIER_INVITATION_ADD_ERROR: {
    event: 'courierInvitation_error',
    component_type: 'form',
  }

};

export const COURIER_CARD_TRACKING_EVENTS = {
  ACTIVE_COURIERS: {
    component_name: 'active couriers', 
    component_type: 'list',
    list_action: 'view',
    list_countsTotal: '',
    event:'list_view',
  },
  PENDING_COURIERS: {
    component_name: 'pending couriers',
    component_type: 'list',
    list_action: 'view',
    list_countsTotal: '',
    event:'list_view',
  },
  ACTIVE_COURIERS_CLICK: {
    component_name: 'active couriers', 
    component_type: 'courier card',
    event:'courierCard_view',
  },
  PENDING_COURIERS_CLICK: {
    component_name: 'pending couriers', 
    component_type: 'courier card',
    event:'courierCard_view',
  }

}

export const COURIER_SETTINGS_TRACKING_EVENTS = {
  SETTINGS_OPEN: {
    event: 'settings_open',
    component_type: 'dialog',
    component_name: 'manage courier settings'
  },
  TOGGLE_ON: {
    event: 'toggle_on',
    component_type: 'toggle',
    component_name: 'tip settings'   
  },
  TOGGLE_OFF: {
    event: 'toggle_off',
    component_type: 'toggle',
    component_name: 'tip settings'     
  }
}

export const COURIER_ORDER_SHOW_HIDE_EVENTS = {
  SETTINGS_OPEN: {
    event: 'settings_open',
    component_type: 'dialog',
    component_name: 'manage courier order settings'
  },
  TOGGLE_ON: {
    event: 'toggle_on',
    component_type: 'toggle',
    component_name: 'manage courier order settings'   
  },
  TOGGLE_OFF: {
    event: 'toggle_off',
    component_type: 'toggle',
    component_name: 'manage courier order settings'     
  }
}

export type TInvitationSendSuccess = TTrackEventData<{
  form_action: string;
  courierDetail: any;
  event_type: string;
  form_countsTotal?: number;
}>;

export type TCourierCardLoad = TTrackEventData<{
  list_action: string;
  list_countsTotal: number;
}>

export type TCourierCardClick = TTrackEventData<{
  courierDetail: string;
}>

export type TCourierAdd = TTrackEventData<{
  courierDetail: string;
}>

export type TSettingsOpen =  TTrackEventData;
export type TToggleOn = TTrackEventData;
export type TToggleOff = TTrackEventData;



export type TInvitationSendStart = TInvitationSendSuccess;
export type TInvitationSendInviteAgain = TInvitationSendSuccess;
export type TInvitationDisconnectStart = TInvitationSendSuccess;
export type TInvitationDisconnectSuccess = TInvitationSendSuccess;
export type TInvitationGuestConnect = TInvitationSendSuccess;
export type TInvitationGuestDecline = TInvitationSendSuccess;
export type TInvitationReInviteStart = TInvitationSendSuccess;
export type TInvitationReInviteSuccess = TInvitationSendSuccess;
export type TInvitationRemoveStart = TInvitationSendSuccess;
export type TInvitationRemoveSuccess = TInvitationSendSuccess;

